export default __webpack_public_path__ + "static/motiondesign-f9a878fd8a7189aabb5c13000ba3505b.png";